export interface TimeSeriesPoint {
	date: string // YYYY-MM-DD
	value: number
}

export interface Mover {
	ticker: string
	exchange: string
	name: string
	change_pct: number
	change_abs: number
}

export interface PerformanceSummary {
	current_value: number
	cost_basis: number
	unrealized_gain: number
	unrealized_gain_pct: number
	dividends_received: number
	total_return: number
	total_return_pct: number
	period_start_value: number
	period_end_value: number
	period_return: number
	period_return_pct: number
	top_movers: Mover[]
	currency: string
}

export interface TimeSeriesResponse {
	data_points: TimeSeriesPoint[]
	range: string
	currency: string
}

export const PERFORMANCE_PERIODS = ["1W", "1M", "3M", "6M", "YTD", "1Y", "ALL"] as const
export type PerformancePeriod = (typeof PERFORMANCE_PERIODS)[number]
